import {useMutation, useQueryClient} from "@tanstack/react-query";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS, RECOMMENDATION_ENDPOINTS} from "../../services/network/endpoints";
import {IEvent, IEventCreate} from "../../services/models/event";
import {toast} from "react-toastify";
import {RecommendationsApi} from "../../services/network/recommendation-api";

export function useUpdateStatusRecom() {
    const queryClient = useQueryClient();
        /*
        * Здесь передаем номер статуса
        * 0 - Выполняется
        * 1 - Оценивается
        * 2 - Выполнен
        * */
    return useMutation({
        mutationKey: [RECOMMENDATION_ENDPOINTS.CHANGE_STATUS],
        mutationFn: ({ recomID, statusNum }: { recomID: string, statusNum: number }) => RecommendationsApi.changeRecommendationStatus(recomID, statusNum),
        onError() {
            toast.error("Не удалось изменить статус");
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.GET, variables.recomID] });
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_BY_SECTOR] });
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_SHORT] });
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.GET_UNREAD_RECOMMS] });
            toast.success("Статус успешно изменен");
        }
    });
}
